// extracted by mini-css-extract-plugin
export default {"ScrollContainer":"ScrollContainer_ScrollContainer__fGyFw","ScrollIndicator":"ScrollContainer_ScrollIndicator__cqDP7","Visible":"ScrollContainer_Visible__lZgul"};